import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import {
    IAIChatAvailabilityResponse,
    IAIChatFeedbackRequest,
    IAIChatRequest,
    IAIChatResponse,
    IAIConversationDetails,
    IAIConversationSummary,
} from '@fi-shared/fi-ai-chat/fi-ai-chat';

@Injectable({ providedIn: 'root' })
export class FiAiChatService {
    constructor(private fiBackend: FiBackendService) {}

    getAvailability(): Promise<IAIChatAvailabilityResponse> {
        return this.fiBackend.fetchData<IAIChatAvailabilityResponse>('AIChat/AIChat/GetAvailability', {
            supressErrorMessage: true,
        });
    }

    sendMessage(request: IAIChatRequest): Promise<IAIChatResponse> {
        return this.fiBackend.fetchDataPost<IAIChatResponse>('AIChat/AIChat/SendMessageToAI', request, {
            supressErrorMessage: true,
        });
    }

    startConversation(prompt: string): Promise<IAIChatResponse> {
        return this.fiBackend.fetchDataPost<IAIChatResponse>(
            'AIChat/AIChat/StartConversation',
            { Prompt: prompt },
            { supressErrorMessage: true },
        );
    }

    getConversations(): Promise<IAIConversationSummary[]> {
        return this.fiBackend.fetchData<IAIConversationSummary[]>('AIChat/AIChat/GetConversations');
    }

    getConversation(conversationId: string): Promise<IAIConversationDetails> {
        return this.fiBackend.fetchData<IAIConversationDetails>(`AIChat/AIChat/GetConversation/${conversationId}`);
    }

    saveFeedback(request: IAIChatFeedbackRequest): Promise<void> {
        return this.fiBackend.fetchDataPost<void>('AIChat/AIChat/SaveFeedback', request, {
            supressErrorMessage: true,
        });
    }
}
